import { useEffect } from 'react';

// HOSTNAME_ENV_MAP: Maps hostname matchers to envCode.
const HOSTNAME_ENV_MAP: Array<[(h: string) => boolean, string]> = [
  [(h) => h === 'localhost', 'local'],
  [(h) => h.includes('tst') || h.includes('test'), 'tst'],
  [(h) => h.includes('sbx'), 'sbx'],
  [(h) => h.includes('qap'), 'qap'],
  [(h) => h.includes('qua'), 'qua'],
  [(h) => h.includes('prd') || h.includes('prod'), 'prd'],
  [(h) => h === 'preview.developer.availity.com', 'prd'],
];

export const getCurrentEnv = (): string | null => {
  const { hostname } = window.location;
  for (const [matcher, envCode] of HOSTNAME_ENV_MAP) {
    if (matcher(hostname)) {
      return envCode;
    }
  }
  return null;
};

const essentialsPrefix = (): string => {
  const env = getCurrentEnv();
  if (env === 'prd') return '';
  if (env === 'qap') return 'qa-';
  if (env === 'qua') return 'qa-';
  if (env === 'sbx') return 'test-';
  if (env === 'tst') return 'test-';
  if (env === 'local') return 'test-';
  return '';
};

const visitorPrefix = (): string => {
  const env = getCurrentEnv();
  if (env === 'prd') return '';
  return env ? `${env}-` : '';
};

declare global {
  interface Window {
    pendo?: {
      initialize: (config: {
        visitor: { id: string };
        account: { id: string };
      }) => void;
    };
  }
}

const usePendo = (akaname: string | undefined): void => {
  useEffect(() => {
    if (akaname === undefined || akaname === null) return;
    let visitorId = akaname
    if (akaname !== '') // Anonymous user
      visitorId = visitorPrefix() + akaname
    // Create and append Pendo script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://${essentialsPrefix()}essentials.availity.com/static/public/appl/shared-essentials-services/pendo/api-dev-portal.js`;
    script.className = 'optanon-category-C0002';

    script.addEventListener('load', () => {
      const { pendo } = window;
      if (pendo) {
        try {
          // Initialize Pendo with the provided user
          pendo.initialize({
            visitor: {
              id: visitorId,
            },
            account: {
              id: "Availity",
            },
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error during Pendo initialization:', error);
        }
      }
    });

    document.head.appendChild(script);
  }, [akaname]);
};

export default usePendo;
